/**
 * View component for /metrics/new
 *
 * Creates a new metric from a copy of the defaultItem in the metric reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as metricActions from '../metricActions';
import * as metricCategoryActions from '../../metricCategory/metricCategoryActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from "../../../global/components/routing/Breadcrumbs.js.jsx";

// import metric components
import MetricForm from '../components/MetricForm.js.jsx';
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';

class CreateMetric extends Base {
  constructor(props) {
    super(props);
    this.state = {
      metric: { ...this.props.defaultMetric }
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
      , formHelpers: {
        hasLDO: 'no'
        , hasINC: 'no'
      }
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(metricCategoryActions.fetchListIfNeeded('all'));
    window.location.assign(`${authoringUrl}/metrics`); // should i remove everything else in this component? 
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });
    this.setState(newState);
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    let newMetric = {...this.state.metric};
    
    if(this.state.formHelpers.hasLDO === 'no') {
      newMetric.likelihoodDeviation = null;
    } else {
      newMetric.likelihoodDeviation = parseInt(this.state.metric.likelihoodDeviation)
    }

    if(this.state.formHelpers.hasINC === 'no') {
      newMetric.impactNonCompliance = null;
    } else {
      newMetric.impactNonCompliance = parseInt(this.state.metric.impactNonCompliance)
    }

    dispatch(metricActions.sendCreateMetric(newMetric)).then((action) => {
      if(action.success) {
        dispatch(metricActions.invalidateList());
        history.push(`/admin/authoring/metrics/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { location, metricCategoryStore } = this.props;
    const { metric } = this.state;
    const isEmpty = (metric.title === null || metric.title === undefined);

    // get the metricCategoryList meta info here so we can reference 'isFetching'
    const metricCategoryList = metricCategoryStore.lists ? metricCategoryStore.lists.all : null;
    const metricCategories = metricCategoryStore.util.getList("all");
    const categoriesEmpty = !metricCategories || !metricCategoryList;

    return (
      <AuthoringLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <Breadcrumbs links={location.state.breadcrumbs} />
            </div>
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <MetricForm
                metric={metric}
                metricCategories={metricCategories}
                cancelLink="/admin/authoring/metrics"
                formHelpers={this.state.formHelpers}
                formTitle="Create Metric"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
    </AuthoringLayout>
    )
  }
}

CreateMetric.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultMetric: store.metric.defaultItem
    , metricCategoryStore: store.metricCategory
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateMetric)
);



// WEBPACK FOOTER //
// modules/metric/views/CreateMetric.js.jsx